module.exports = __webpack_public_path__ + "img/36.very_good.79e86b21.svg";